import { Fragment, useState, useEffect } from "react";
import { Modal, Button, Spin, Result, notification, Upload } from "antd";
import { Searcher, TableAntd, TitleHeader } from "../../components/commons";
import { ExclamationCircleOutlined, FileExcelOutlined } from "@ant-design/icons";
import { getSorteos, updateOne } from "../../api/sorteo";
import { columnsSorteo } from "./formatTable";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import { uploadProps } from "../../utils/functions";
import SorteoEditarNombre from "./SorteoEditarNombre";

function ListaSorteo() {
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);
  const history = useHistory();
  const { user } = useAuth();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [dataToTable, setDataToTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [reload, setReload] = useState(false);

  const fetchDataToTable = async () => {
    try {
      setIsLoading(true);
      const res = await getSorteos();
      setDataToTable(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
      setDataToTable([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDataToTable();
  }, [reload]);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  const closeModal = () => {
    setIsModalVisible(false);
  };

  // ------ Show modal edit record -----------
  const showEditModal = (record) => {
    setIsModalVisible(true); //mostrar modal
    setModalTitle("Editar sorteo");
    setModalContent(
      <SorteoEditarNombre
        record={record}
        closeModal={closeModal}
        reload={() => setReload(!reload)}
      />
    );
  };

  const handleDelete = (record) => {
    Modal.confirm({
      title: (
        <p>
          ¿Estás seguro de eliminar el sorteo <b className="text-blue-600">{}</b>?
        </p>
      ),
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        try {
          const res = await updateOne({ isEliminado: "1" }, record._id);

          if (res.success) {
            notification.success({
              message: "Operación exitosa",
              description: `Se ha eliminado el sorteo satistactoriamente.`
            });
            setReload(!reload);
          }
        } catch (err) {
          notification.error({
            message: "Operación no válida",
            description: `No se pudo eliminar, comuníquese con el administrador.`
          });
        }
      },
      onCancel() {
        return null;
      }
    });
  };

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  // ------ Show modal delete record -----------
  const onChangeState = (record) => {
    const activateMsg = record.isActivo ? "ocultar" : "publicar";
    const actionMsg = record.isActivo ? "ocultado" : "publicado";

    Modal.confirm({
      title: `¿Estás seguro de ${activateMsg} el sorteo '${record.nombre}?'`,
      icon: <ExclamationCircleOutlined />,
      okText: "Sí, " + activateMsg,
      cancelText: "Cancelar",
      onOk() {
        updateOne({ isActivo: !record.isActivo }, record._id)
          .then((res) => {
            if (res.success) {
              notification.success({
                message: "Operación exitosa",
                description: `Se ha ${actionMsg} el sorteo satistactoriamente.`
              });
              fetchDataToTable();
            }
          })
          .catch((err) => {
            notification.error({
              message: "Operación no válida",
              description: `No se pudo actualizar el estado, comuníquese con el administrador.`
            });
          });
      }
    });
  };

  const search = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  const showDetails = (record) => {
    history.push("/app/sorteo/" + record.codigo);
  };

  // ------ Formato para que se muestre en la tabla ------
  const columnsToTable = columnsSorteo(
    page,
    onChangeState,
    showDetails,
    showEditModal,
    handleDelete
  );

  return (
    <Fragment>
      <TitleHeader
        title={`(${dataToTable.length || 0}) SORTEOS REALIZADOS`}
        extra={
          <Upload
            {...uploadProps({
              name: "sor_sorteo",
              action: "/sorteo/upload",
              data: { nrodocumento: user.documentNumber },
              makeReload: () => setReload(!reload)
            })}
            showUploadList={false}
            maxCount={1}
            accept=".xlsx"
          >
            <Button
              icon={<FileExcelOutlined />}
              className="text-white rounded-md text-sm h-9 px-5 bg-green-500 hover:bg-green-600 hover:shadow-lg"
            >
              Subir sorteo manual
            </Button>
          </Upload>
        }
      />

      <Searcher onSearch={search} placeholder="Busca algún posible participante" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? dataToTable : filterTable}
        setPage={setPage}
      />

      <Modal
        title={modalTitle}
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </Fragment>
  );
}

export default ListaSorteo;
